import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import { networkErrorHandler } from 'utils/errrorHandlers';
import SmsActionTypes from './types';
import {
  fetchSmsConfigurationSuccess,
  fetchSmsConfigurationFailure,
  updateSmsConfigurationSuccess,
  updateSmsConfigurationFailure,
  fetchSmsLogsSuccess,
  fetchSmsLogsFailure,
} from './actions';

const { API_BASE_URL } = urls || {};

function* fetchConfiguration() {
  const response = yield request({
    method: 'get',
    url: `${API_BASE_URL}/sms/configuration`,
  });
  if (response.success) {
    yield put(fetchSmsConfigurationSuccess(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, `Failed to load SMS configuration: ${response.message}`);
    yield put(fetchSmsConfigurationFailure(response.message));
  }
}

function* updateConfiguration({ payload: { data, cb } }) {
  const response = yield request({
    method: 'put',
    url: `${API_BASE_URL}/sms/configuration`,
    data,
  });
  if (response.success) {
    yield put(updateSmsConfigurationSuccess(response.raw));
    Notify('Multitexter API key saved', { status: 'success' });
    if (cb) cb(response.raw);
  } else {
    networkErrorHandler(response?.statusCode, `Failed to save SMS configuration: ${response.message}`);
    yield put(updateSmsConfigurationFailure(response.message));
  }
}

function* fetchLogs({ payload }) {
  const { page = 0, size = 10, q } = payload || {};
  const params = { page, size };
  if (q) params.q = q;
  const response = yield request({
    method: 'get',
    url: `${API_BASE_URL}/sms/logs`,
    params,
  });
  if (response.success) {
    yield put(fetchSmsLogsSuccess(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, `Failed to load SMS logs: ${response.message}`);
    yield put(fetchSmsLogsFailure(response.message));
  }
}

export default function* smsConfigurationSaga() {
  yield takeEvery(SmsActionTypes.FETCH_SMS_CONFIGURATION, fetchConfiguration);
  yield takeEvery(SmsActionTypes.UPDATE_SMS_CONFIGURATION, updateConfiguration);
  yield takeLatest(SmsActionTypes.FETCH_SMS_LOGS, fetchLogs);
}
